import React, { useState } from "react";
import { motion } from "framer-motion";
import { ChevronLeftIcon, ChevronRightIcon, MoreVerticalIcon } from "lucide-react";
import { REVIEWS } from "../lib/data";
import { Stars } from "./Stars";
export function TestimonialCarousel() {
  const [activeIndex, setActiveIndex] = useState(0);
  const review = REVIEWS[activeIndex];
  function showPrevious() {
    setActiveIndex(current => (current - 1 + REVIEWS.length) % REVIEWS.length);
  }
  function showNext() {
    setActiveIndex(current => (current + 1) % REVIEWS.length);
  }
  return <section className="mt-5" aria-label="Reseñas de fisioterapeutas" data-id="element-201" data-mp="22v94jwol1wq1">
      <div className="mb-2 flex items-center justify-between px-1" data-id="element-202" data-mp="27v3thuossc8g">
        <p className="text-xs font-bold uppercase tracking-wide text-slate-500" data-id="element-203" data-mp="2cnncx8a621l6">
          Mensajes de la comunidad
        </p>
        <span className="text-xs font-semibold text-slate-400" data-id="element-204" data-mp="1f7hs8t31ljor">{activeIndex + 1} de {REVIEWS.length}</span>
      </div>

      <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm" data-id="element-205" data-mp="1k4zs7tz30okm">
        <motion.article key={review.name} initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.22,
        ease: "easeOut"
      }} className="p-4" aria-live="polite" data-id="element-206" data-mp="343e8dnyt474p">
          <div className="flex items-start gap-3" data-id="element-207" data-mp="2pbdukp3mzqbb">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-teal-600 font-display text-sm font-extrabold text-white" data-id="element-208" data-mp="2pakrby3vzixx">
              {review.name.charAt(0)}
            </div>
            <div className="min-w-0 flex-1" data-id="element-209" data-mp="2bcns0ty1syfk">
              <div className="flex items-start justify-between gap-2" data-id="element-210" data-mp="2bdfglkt89vwc">
                <div data-id="element-211" data-mp="26e2xnb5h98z1">
                  <p className="text-sm font-bold text-slate-800" data-id="element-212" data-mp="26eupqbzv8okk">{review.name}</p>
                  <p className="text-xs text-slate-500" data-id="element-213" data-mp="9lj70gqmew47">
                    para mí <span aria-hidden="true" data-id="element-214" data-mp="4m6ilrk3pgzi">⌄</span>
                  </p>
                </div>
                <div className="flex items-center gap-2 text-xs text-slate-400" data-id="element-215" data-mp="1z2epm6jjn1ta">
                  <span data-id="element-216" data-mp="1z0bp2skrlqab">hoy</span>
                  <MoreVerticalIcon className="h-4 w-4" aria-hidden="true" data-id="element-217" data-mp="23sv5ryer11jc" />
                </div>
              </div>
              <p className="mt-3 text-sm font-bold text-slate-800" data-id="element-218" data-mp="1p50bidl3ep45">
                Asunto: Por fin tengo la consulta organizada
              </p>
              <Stars className="mt-2" size={14} data-id="element-219" data-mp="1u18ww8pvvejr" />
              <p className="mt-2 text-[13.5px] leading-relaxed text-slate-600" data-id="element-220" data-mp="2hsmp8eo1ba4q">
                {review.text}
              </p>
              <p className="mt-3 text-xs font-medium text-teal-700" data-id="element-221" data-mp="2mrh63b2fyom7">
                {review.role} · {review.city}
              </p>
            </div>
          </div>
        </motion.article>

        <div className="flex items-center justify-between border-t border-slate-100 px-3 py-2.5" data-id="element-222" data-mp="2csi4gcg3ft8p">
          <button type="button" onClick={showPrevious} className="rounded-lg p-1.5 text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-800 focus:outline-none focus:ring-2 focus:ring-teal-500" aria-label="Ver reseña anterior" data-id="element-223" data-mp="xc9n2p9ni4pg">
            <ChevronLeftIcon className="h-4 w-4" data-id="element-224" data-mp="ov91dpzc514u" />
          </button>
          <div className="flex gap-1.5" aria-hidden="true" data-id="element-225" data-mp="13tujr80pzuvw">
            {REVIEWS.map((item, index) => <span key={item.name} className={`h-1.5 rounded-full transition-all ${index === activeIndex ? "w-4 bg-teal-600" : "w-1.5 bg-slate-300"}`} data-id="element-226" data-mp="ytyivhnbkjkk" data-mpi={index} />)}
          </div>
          <button type="button" onClick={showNext} className="rounded-lg p-1.5 text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-800 focus:outline-none focus:ring-2 focus:ring-teal-500" aria-label="Ver siguiente reseña" data-id="element-227" data-mp="6741itlsu0bb">
            <ChevronRightIcon className="h-4 w-4" data-id="element-228" data-mp="3ohz2vs3dhrp5" />
          </button>
        </div>
      </div>
    </section>;
}